import { StatusPill } from "../BisWidgets";
import { dossierListShellStyle, dossierTableCardStyle, dossierToolbarStyle } from "../bisLayoutStyles";
import { SearchableEhpadField } from "../../shared/components/SearchableEhpadField";
import { formatDate } from "../../shared/controleFormat";
import { tdStyle, thStyle } from "../../shared/styles/layoutStyles";

export function renderDossierList(view) {
    const { filteredDossiers, openDossier, workspace } = view;
    const latestDossier = filteredDossiers
        .slice()
        .sort((a, b) => String(b.updatedAt || "").localeCompare(String(a.updatedAt || "")))[0];

    return (
    <div style={dossierListShellStyle}>
        <div style={dossierToolbarStyle}>
            <div style={{ display: "grid", gridTemplateColumns: "minmax(260px, 420px) auto", gap: "12px", alignItems: "end" }}>
                <div>
                    <label htmlFor="controle-bis-list-ehpad" style={{ display: "block", fontSize: "12px", color: "#64748b", marginBottom: "6px", fontWeight: 700 }}>EHPAD</label>
                    <SearchableEhpadField
                        id="controle-bis-list-ehpad"
                        ehpads={workspace.ehpads}
                        value={workspace.selectedEhpadId}
                        onChange={(id) => {
                            workspace.setSelectedEhpadId(id);
                            workspace.setActiveDossier(null);
                        }}
                        placeholder="Rechercher ou afficher tous"
                        allowClear
                    />
                </div>
                <div style={{ color: "#64748b", fontSize: "13px", paddingBottom: "8px", lineHeight: 1.4 }}>
                    {workspace.selectedEhpadId
                        ? `${filteredDossiers.length} fiche${filteredDossiers.length > 1 ? "s" : ""} pour ${workspace.selectedEhpad?.nom || "cet EHPAD"}`
                        : `${filteredDossiers.length} fiche${filteredDossiers.length > 1 ? "s" : ""} au total`}
                    {latestDossier?.updatedAt ? (
                        <span style={{ display: "block", color: "#94a3b8", fontSize: "12px", marginTop: "2px" }}>
                            Dernière activité : {new Date(latestDossier.updatedAt).toLocaleString("fr-FR")}
                        </span>
                    ) : null}
                </div>
            </div>
        </div>

        <div style={dossierTableCardStyle}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                    <tr style={{ background: "#f8fafc" }}>
                        <th style={thStyle}>Date production</th>
                        <th style={thStyle}>EHPAD</th>
                        <th style={thStyle}>N° lot</th>
                        <th style={thStyle}>Statut</th>
                        <th style={thStyle}>Dernière modification</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredDossiers.map(dossier => (
                        <tr
                            key={dossier.id}
                            onClick={() => openDossier(dossier)}
                            onContextMenu={event => workspace.openContextMenu(event, dossier)}
                            title="Clic droit pour les actions"
                            style={{ cursor: "pointer" }}
                            onMouseEnter={e => e.currentTarget.style.background = "#f8fafc"}
                            onMouseLeave={e => e.currentTarget.style.background = "transparent"}
                        >
                            <td style={{ ...tdStyle, fontWeight: 900, color: "#0f172a" }}>{formatDate(dossier.dateProduction)}</td>
                            <td style={tdStyle}>{dossier.ehpadNom}</td>
                            <td style={{ ...tdStyle, color: "#475569", fontWeight: 800 }}>{dossier.numeroLot}</td>
                            <td style={tdStyle}>
                                <StatusPill status={dossier.status} />
                            </td>
                            <td style={tdStyle}>{dossier.updatedAt ? new Date(dossier.updatedAt).toLocaleString("fr-FR") : "—"}</td>
                        </tr>
                    ))}
                    {filteredDossiers.length === 0 && (
                        <tr>
                            <td colSpan={5} style={{ padding: "34px", textAlign: "center", color: "#94a3b8" }}>
                                {workspace.selectedEhpadId ? "Aucune fiche pour cet EHPAD." : "Sélectionnez un EHPAD ou créez une fiche de contrôle."}
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    </div>
    );
}
